import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from "react-router";
import { useTranslation } from 'react-i18next';
import { callNativeWeb, footerShowEventWeb } from 'common/appInterface';
import CardApplyStopModal from 'components/CardApplyStopModal';
import { Location } from 'history';

const IdcardSelectPage: React.FC = () => {
  /** Location State */
  const location = useLocation() as Location<LocationState>;
  /** Navigate */
  const navigate = useNavigate();
  /** 다국어처리 */
  const { t, i18n } = useTranslation();

  const screenId = "APPL08";
  const screenName = t("APPL08.title");

  const [cardApply] = useState<Partial<CardApplyStep4>>(location.state.apply);

  const [isStop, setStop] = useState(false);
  const closeStop = useCallback(() => setStop(false), []);

  /** 뒤로가기 처리 (backKeyEvent_App (APP > WEB)) */
  const callbackBackkeyEvent = useCallback(() => {
    setStop(true);
  }, []);

  /** 신분증업로드 이동 */
  const clickList = useCallback((type: string) => {
    navigate("/apply/step4/upload", { state: { ...location.state, apply: { ...cardApply, idcardDivisionCode: type }}});
  }, [navigate, location, cardApply]);

  // 최초실행
  useEffect(() => {
    // 언어설정
    i18n.changeLanguage(location.state.query.languageCode);
    // callNative_Web 처리 (WEB > APP)
    callNativeWeb(screenId, screenName);
    // 하단바 숨기기
    footerShowEventWeb("N");

    console.log("QUERY STATE");
    console.log(location.state);
    console.log(cardApply);

    // 최초한번실행 useEffect() Warning 제거
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 뒤로가기 이벤트 리스너 (backKeyEvent_App (APP > WEB))
  useEffect(() => {
    document.addEventListener("backpress", callbackBackkeyEvent);
    return () => document.removeEventListener("backpress", callbackBackkeyEvent);
  }, [callbackBackkeyEvent]);

  return (
    <div id="wrap">
      <div id="container" className="pcHidden">
        <section className="contents myPageSetting">
          <div className="inner">
            <div className="settingListWrap clfix">
              <dl className="settingList2">
                <dt><span className="tit">{t("APPL08.explan01")}</span></dt>
                {cardApply.foreignerDivisionCode === "1" && 
                  <dd><button type="button" onClick={() => clickList("1")}><div className="icon"><img src="/assets/images/ico/icon_namecard.png" alt="주민등록증" /></div><span className="tit">{t("APPL08.menu01")}</span></button></dd>
                }
                {cardApply.foreignerDivisionCode === "1" && 
                  <dd><button type="button" onClick={() => clickList("2")}><div className="icon"><img src="/assets/images/ico/icon_namecard.png" alt="운전면허증" /></div><span className="tit">{t("APPL08.menu02")}</span></button></dd>
                }
                {cardApply.foreignerDivisionCode === "2" && 
                  <dd><button type="button" onClick={() => clickList("3")}><div className="icon"><img src="/assets/images/ico/icon_namecard.png" alt="외국인등록증" /></div><span className="tit">{t("APPL08.menu03")}</span></button></dd>
                }
                {cardApply.foreignerDivisionCode === "2" && 
                  <dd><button type="button" onClick={() => clickList("4")}><div className="icon"><img src="/assets/images/ico/icon_passport.png" alt="여권" /></div><span className="tit">{t("APPL08.menu04")}</span></button></dd>
                }
              </dl>
            </div>
          </div>
        </section>
      </div>
      <CardApplyStopModal isStop={isStop} closeStop={closeStop} />
    </div>
  );
};

export default IdcardSelectPage;